module.exports = __webpack_public_path__ + "img/bullet-leaf.9b20204.svg";